<template functional>
	<component :is="props.properties.component" v-bind="props.properties.data" v-on="listeners">
		<template #trigger>
			<slot name="trigger"></slot>
		</template>
		<slot name="default"></slot>
	</component>
</template>

<script>
export default {
	name: "Switcher",
	props: ["properties"]
}
</script>
